module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.getItemsLength(_vm.items) > _vm.perpage) ? _c('div', {
    staticClass: "pagination"
  }, [_c('div', {
    staticClass: "prev",
    class: {
      hidden: ((_vm.page) < 2)
    },
    on: {
      "click": function($event) {
        return _vm.prevPage()
      }
    }
  }, [_vm._v("<")]), _vm._v(" "), _vm._l((_vm.getNumberPages()), function(i) {
    return _c('div', {
      staticClass: "page",
      class: {
        'active': ((_vm.page) == i)
      },
      on: {
        "click": function($event) {
          return _vm.setPage(i)
        }
      }
    }, [_vm._v(_vm._s(i))])
  }), _vm._v(" "), _c('div', {
    staticClass: "next",
    class: {
      hidden: ((_vm.page) + 1 > _vm.getNumberPages())
    },
    on: {
      "click": function($event) {
        return _vm.nextPage()
      }
    }
  }, [_vm._v(">")])], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a30feb2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pagination.vue
// module id = 613
// module chunks = 1